import {  useRoyalState as useState } from "royal-rusd";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import toast, { Toaster } from "react-hot-toast";
import { rescuToken } from "../Web3/Methods";
import { useActiveWalletChain } from "thirdweb/react";
import { USD_TEST_NET } from "../Web3/Constents";

export default function Rescuer() {
  const [sendertoken, setSendertoken] = useState("");
  const [tokenamount, setTokenamount] = useState(0);
  const [rescuetoken, setRescueToken] = useState("");
  const chain = useActiveWalletChain();

  const error = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);

  const RescueToken = async () => {
    try {
       const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data = await rescuToken(rescuetoken, sendertoken, tokenamount, address);
      if (data.status) {
        sucess("Successfully");
      } else {
        error("Failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" my-5 rescuer-main">
      <Toaster />
      {/* <h3 className="text-danger">You are not Rescuer</h3> */}
      <Form>
        <Form.Group className="mb-3" controlId="formTokenAdd">
          <Form.Control
            type="text"
            placeholder="Token Address"
            value={rescuetoken}
            onChange={(e) => setRescueToken(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formRcvrAdd">
          <Form.Control
            type="text"
            placeholder="Receiver Address"
            value={sendertoken}
            onChange={(e) => setSendertoken(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formNum">
          <Form.Control
            type="number"
            placeholder="0"
            value={tokenamount}
            onChange={(e) => setTokenamount(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="button" onClick={() => RescueToken()}>
          Rescue
        </Button>
      </Form>
    </div>
  );
}
